Ext.define('SA.SessionPingTask', {
    constructor(failureListener) {
        this.failureListener = failureListener;

        SA.Ajax.onSendingRequest(this.onAjaxSendingRequest, this);

        this.task = new Ext.util.DelayedTask(() => {
            Ext.getDoc().un('click', this.performPing, this);
            Ext.getDoc().on('click', this.performPing, this, {single: true});
        });
    },

    cancel() {
        this.task.cancel();
    },

    onAjaxSendingRequest() {
        this.task.delay(5 * 60 * 1000);
    },

    performPing() {
        SA.Ajax.request({
            resource: 'user',

            failure: error => {
                if (error.isSessionDirtyError()) {
                    error.flagUnexpected();
                    return;
                }

                this.failureListener();
            }
        });
    }
});